import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, renderList as _renderList, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup__content"
}
const _hoisted_2 = { class: "download-documents" }
const _hoisted_3 = { class: "download-documents__warning" }
const _hoisted_4 = { class: "download-documents__text" }
const _hoisted_5 = { class: "download-documents__info" }
const _hoisted_6 = { class: "download-documents__main-info" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "download-documents__card-info card-info" }
const _hoisted_9 = { class: "card-info__title" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "card-info__number" }
const _hoisted_13 = {
  key: 3,
  class: "text-secondary"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 3,
  class: "d-flex align-items-center gap-xs"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 4,
  class: "d-flex align-items-center gap-xs"
}
const _hoisted_20 = { class: "card-info__name" }
const _hoisted_21 = { class: "download-form" }
const _hoisted_22 = {
  class: "download-form__text",
  id: "file-text"
}
const _hoisted_23 = {
  key: 0,
  class: "d-block text-secondary mb-2"
}
const _hoisted_24 = { class: "col-sm-12" }
const _hoisted_25 = { class: "me-2" }
const _hoisted_26 = {
  key: 0,
  class: "spinner-border",
  role: "status",
  style: {"zoom":"0.5"}
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "popup__controls" }
const _hoisted_30 = { class: "text-capitalize-first" }
const _hoisted_31 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_PayoutQrBlock = _resolveComponent("PayoutQrBlock")!
  const _component_VietQrPaymentBlock = _resolveComponent("VietQrPaymentBlock")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "",
    title: _ctx.$t('labels.payout_upload_files_title'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      (_ctx.deal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "download-documents__icon" }, [
                  _createElementVNode("svg", {
                    width: "26",
                    height: "24",
                    viewBox: "0 0 26 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M10.5759 1.49171C11.6527 -0.375491 14.3471 -0.375491 15.4239 1.49171L25.4719 18.8917C26.5487 20.7589 25.1999 23.0917 23.0463 23.0917H2.95188C0.796679 23.0917 -0.550521 20.7589 0.527879 18.8917L10.5759 1.49171ZM12.9999 5.49971C13.3181 5.49971 13.6234 5.62614 13.8484 5.85118C14.0735 6.07622 14.1999 6.38145 14.1999 6.69971V12.2997C14.1999 12.618 14.0735 12.9232 13.8484 13.1482C13.6234 13.3733 13.3181 13.4997 12.9999 13.4997C12.6816 13.4997 12.3764 13.3733 12.1514 13.1482C11.9263 12.9232 11.7999 12.618 11.7999 12.2997V6.69971C11.7999 6.38145 11.9263 6.07622 12.1514 5.85118C12.3764 5.62614 12.6816 5.49971 12.9999 5.49971ZM12.9999 19.8997C13.4242 19.8997 13.8312 19.7311 14.1313 19.4311C14.4313 19.131 14.5999 18.7241 14.5999 18.2997C14.5999 17.8754 14.4313 17.4684 14.1313 17.1683C13.8312 16.8683 13.4242 16.6997 12.9999 16.6997C12.5755 16.6997 12.1686 16.8683 11.8685 17.1683C11.5685 17.4684 11.3999 17.8754 11.3999 18.2997C11.3999 18.7241 11.5685 19.131 11.8685 19.4311C12.1686 19.7311 12.5755 19.8997 12.9999 19.8997Z",
                      fill: "#FF4747"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('labels.payout_confirmation_warning')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _cache[2] || (_cache[2] = _createTextVNode(" ID ")),
                    _createElementVNode("b", null, _toDisplayString(_ctx.deal?.publicId), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('labels.sum')), 1),
                    _cache[3] || (_cache[3] = _createTextVNode(": ")),
                    _createElementVNode("b", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal?.takerSum)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_PayMethodIcon, {
                      method: _ctx.deal.paymentMethod
                    }, null, 8, ["method"]),
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t(`payment_options.${_ctx.deal.paymentOption}`)) + " ", 1),
                      (_ctx.deal.requisites?.crossBorderCurrency)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.deal.requisites?.crossBorderCurrency), 1))
                        : _createCommentVNode("", true),
                      _cache[4] || (_cache[4] = _createTextVNode()),
                      (_ctx.deal.requisites?.paymentSystem)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.helper.trans('payment_systems.' + _ctx.deal.requisites?.paymentSystem)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.deal.payoutQr?.link)
                      ? (_openBlock(), _createBlock(_component_PayoutQrBlock, {
                          key: 0,
                          link: _ctx.deal.payoutQr.link
                        }, null, 8, ["link"]))
                      : (_ctx.helper.isEmvQrOption(_ctx.deal.paymentOption))
                        ? (_openBlock(), _createBlock(_component_VietQrPaymentBlock, {
                            key: 1,
                            "deal-id": _ctx.deal.id,
                            "qr-code-data": _ctx.deal.qrCodeData ?? null,
                            "qr-code-link": _ctx.helper.emvQrData(_ctx.deal),
                            "fallback-requisites": _ctx.deal.paymentRequisites.requisites || ''
                          }, null, 8, ["deal-id", "qr-code-data", "qr-code-link", "fallback-requisites"]))
                        : (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(_ctx.deal))
                          ? (_openBlock(), _createBlock(_component_VietQrPaymentBlock, {
                              key: 2,
                              "deal-id": _ctx.deal.id,
                              "qr-code-data": null,
                              "qr-code-link": _ctx.helper.dealQrCodeLink(_ctx.deal),
                              "fallback-requisites": ''
                            }, null, 8, ["deal-id", "qr-code-link"]))
                          : (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.$t('labels.manual_sbp_qr_awaiting_link')), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (_ctx.deal.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: _ctx.deal.paymentRequisites.requisites,
                                      target: "_blank"
                                    }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_14))
                                  : (_ctx.deal.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: _ctx.deal.paymentRequisites.requisites,
                                        target: "_blank"
                                      }, _toDisplayString(_ctx.helper.trans('labels.my_click_uz')), 9, _hoisted_15))
                                    : (_ctx.deal.paymentOption === _ctx.PaymentOption.TIPS && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          href: _ctx.deal.paymentRequisites.requisites,
                                          target: "_blank"
                                        }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_16))
                                      : (_ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createElementVNode("a", {
                                              href: _ctx.deal.paymentRequisites.requisites,
                                              target: "_blank"
                                            }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_18),
                                            _cache[5] || (_cache[5] = _createTextVNode()),
                                            _createVNode(_component_copy_button, {
                                              value: _ctx.deal.paymentRequisites.requisites
                                            }, null, 8, ["value"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createTextVNode(_toDisplayString(_ctx.deal.paymentRequisites.requisites) + " ", 1),
                                            _createVNode(_component_copy_button, {
                                              value: _ctx.deal.paymentRequisites.requisites
                                            }, null, 8, ["value"])
                                          ]))
                              ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.deal.paymentRequisites.holder), 1)
                ])
              ])
            ]),
            _createElementVNode("form", _hoisted_21, [
              _createElementVNode("div", _mergeProps({
                class: "download-form__container",
                id: "drop-area"
              }, _ctx.dropzone.getRootProps()), [
                _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                _cache[6] || (_cache[6] = _createElementVNode("svg", {
                  width: "48",
                  height: "48",
                  viewBox: "0 0 48 48",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M35.25 33H25.5V18.6216L30.4397 23.5603C30.7233 23.8297 31.1009 23.9777 31.4921 23.9727C31.8832 23.9677 32.2569 23.8101 32.5335 23.5335C32.8101 23.2569 32.9677 22.8832 32.9727 22.492C32.9777 22.1009 32.8297 21.7233 32.5603 21.4397L25.0603 13.9397C24.779 13.6586 24.3977 13.5007 24 13.5007C23.6023 13.5007 23.221 13.6586 22.9397 13.9397L15.4397 21.4397C15.1703 21.7233 15.0223 22.1009 15.0273 22.492C15.0323 22.8832 15.1899 23.2569 15.4665 23.5335C15.7431 23.8101 16.1168 23.9677 16.508 23.9727C16.8991 23.9777 17.2767 23.8297 17.5603 23.5603L22.5 18.6216V33H12.75C11.3581 32.9985 10.0236 32.4449 9.03933 31.4607C8.05509 30.4764 7.50149 29.1419 7.5 27.75V8.25C7.50149 6.85807 8.05509 5.52358 9.03933 4.53933C10.0236 3.55509 11.3581 3.00149 12.75 3H35.25C36.6419 3.00149 37.9764 3.55509 38.9607 4.53933C39.9449 5.52358 40.4985 6.85807 40.5 8.25V27.75C40.4985 29.1419 39.9449 30.4764 38.9607 31.4607C37.9764 32.4449 36.6419 32.9985 35.25 33ZM25.5 43.5C25.5 43.8978 25.342 44.2794 25.0607 44.5607C24.7794 44.842 24.3978 45 24 45C23.6022 45 23.2206 44.842 22.9393 44.5607C22.658 44.2794 22.5 43.8978 22.5 43.5V33H25.5V43.5Z",
                    fill: "#77818D"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('labels.payout_upload_files')), 1)
              ], 16),
              (_ctx.stopScamEnabled)
                ? (_openBlock(), _createElementBlock("small", _hoisted_23, _toDisplayString(_ctx.$t('stopscam.file_hint')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileAttachments, (fileAttachment) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row mb-2 ms-2",
                  key: fileAttachment.id
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_svg_icon, {
                      class: "icon icon__warning icon__small",
                      icon: "paperclip"
                    }),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(fileAttachment.file.name), 1),
                    (fileAttachment.error === null && fileAttachment.attachment === null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[7] || (_cache[7] = [
                          _createElementVNode("span", { class: "visually-hidden" }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.removeFile(fileAttachment)), ["prevent"])
                        }, [
                          _createVNode(_component_svg_icon, {
                            class: "icon icon__attention icon__small",
                            icon: "xmark"
                          })
                        ], 8, _hoisted_27)),
                    _createElementVNode("div", null, [
                      (fileAttachment.error !== null)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(fileAttachment.error), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
                  class: "btn popup__close"
                }, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('button.cancel')), 1)
                ]),
                _createVNode(_component_LoaderButton, {
                  "on-click": _ctx.confirmPayout,
                  class: "btn btn--reset"
                }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createElementVNode("svg", {
                      width: "12",
                      height: "10",
                      viewBox: "0 0 12 10",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M11.2044 1.6485L4.74285 9.34081C4.67197 9.42524 4.58377 9.49344 4.48423 9.5408C4.3847 9.58817 4.27614 9.61358 4.16592 9.61533H4.15294C4.04512 9.61529 3.93852 9.59259 3.84004 9.54869C3.74156 9.5048 3.65341 9.44069 3.58131 9.36052L0.812078 6.2836C0.741749 6.20901 0.68704 6.12111 0.651168 6.02507C0.615295 5.92903 0.598982 5.82679 0.603186 5.72436C0.607391 5.62193 0.632028 5.52137 0.675651 5.42859C0.719274 5.33581 0.781003 5.2527 0.857208 5.18412C0.933414 5.11554 1.02256 5.06289 1.1194 5.02925C1.21625 4.99562 1.31884 4.98168 1.42115 4.98826C1.52346 4.99484 1.62342 5.02181 1.71515 5.06757C1.80689 5.11334 1.88856 5.17698 1.95535 5.25475L4.13275 7.67399L10.0265 0.659081C10.1587 0.506234 10.3457 0.411551 10.5472 0.395499C10.7486 0.379446 10.9483 0.443313 11.1031 0.573295C11.2578 0.703277 11.3552 0.888932 11.3741 1.09013C11.3931 1.29133 11.3321 1.4919 11.2044 1.6485Z",
                        fill: "#F7F9FC"
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('deals.action.confirm_payout')), 1)
                  ]),
                  _: 1,
                  __: [9]
                }, 8, ["on-click"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}